export default "__VITE_ASSET__BFyAsvce__"